"use client";
import { useState } from "react";
import BusinessDetailsStep from "../../pages/BusinessDetailsStep";
import BasicDetailsStep from "../../pages/BasicDetailsStep";
import BankDetailsStep from "../../pages/BankDetailsStep";
import KYCVerificationStep from "../../pages/KYCVerificationStep";
import ProgressBar from "../../pages/ProgressBar";
// import Header from "../api/Header";
import SuccessModal from "../../pages/SuccessModal";
import ThemeMaker from "../../components/thememaker";

const TOTAL_STEPS = 4;

export default function OnboardingForm() {
    const [currentStep, setCurrentStep] = useState(1);
    const [showSuccess, setShowSuccess] = useState(false);

    const handleNext = () => {
        if (currentStep < TOTAL_STEPS) {
            setCurrentStep((s) => s + 1);
        } else {
            setShowSuccess(true);
        }
    };


    const handleBack = () => {
        if (currentStep > 1) setCurrentStep((s) => s - 1);
    };

    const renderStep = () => {
        switch (currentStep) {
            case 1: return <BusinessDetailsStep />;
            case 2: return <BasicDetailsStep />;
            case 3: return <BankDetailsStep />;
            case 4: return <KYCVerificationStep />;
            default: return null;
        }
    };

    return (
        <ThemeMaker>
            {/* <Header /> */}
            <SuccessModal
                show={showSuccess}
                onClose={() => setShowSuccess(false)}
            />

            <div className="bg-light min-vh-100 mt-0 pt-0">
                <div className="">
                    <div className="container px-5">
                        <div className="mx-auto">
                            <ProgressBar currentStep={currentStep} />
                        </div>
                    </div>
                </div>

                <main className="container py-3">
                    <div className="mx-auto px-5">

                        {renderStep()}

                        <div className="d-flex justify-content-between mt-4">
                            {currentStep > 1 ? (
                                <button style={{ border: "1px solid #F75710", color: "#F75710", outline: "none" }}
                                    onClick={handleBack}
                                    className="bg-white shadow-none px-4 rounded rounded-3 fw-semibold"
                                >
                                    Back
                                </button>
                            ) : (
                                <div />
                            )}

                            <button
                                type="button"
                                style={{ background: "linear-gradient(90deg, #F75710 -51.11%, #FC8809 48.89%)", outline: "none", border: "none" }}
                                onClick={handleNext}
                                className="border-none p-2 rounded rounded-3 text-white shadow-none px-4 fw-semibold"
                            >
                                {currentStep === TOTAL_STEPS ? "Submit" : "Next"}
                            </button>

                        </div>
                    </div>
                </main>
            </div>
        </ThemeMaker>
    );
}
